import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const AdmissionXI = () => {
     useEffect(() => {
        document.title = 'Admission Class XI -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
            
          </li>
          <li> Admission Class XI Information </li>
          <li>Admission Class XI Information</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Admission Class XI Information </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h3>
                REGISTRATION OPEN FOR CLASS XI (SESSION 2027-28) FROM SEPTEMBER
                28, 2026
              </h3>

              <p>
                <b>STREAMS: </b>
              </p>
              <ul className="list">
                <li>NON-MEDICAL</li>
                <li>MEDICAL</li>
                <li>COMMERCE (with Maths & without Maths)</li>
                <li>HUMANITIES (with IT / without IT)</li>
              </ul>

              <p>
                <b>ADMISSION CRITERIA: </b>
              </p>
              <ul className="list">
                <li>
                  <strong>MEDICAL/NON-MEDICAL:</strong> Minimum 70% and above
                  for Entrance Examination.
                </li>
                <li>
                  <strong>COMMERCE:</strong> Minimum 65% and above for Entrance
                  Examination.
                </li>
                <li>
                  <strong>HUMANITIES (with IT / without IT):</strong> Minimum 65% and above
                  for Entrance Examination.
                </li>
              </ul>

              <p>
                <b>IMPORTANT DATES: </b>
              </p>
              <ul className="list">
                <li>
                  Online/Offline Registration:
                  <strong>28th September 2026 onwards</strong>.
                </li>
                <li>
                  Entrance Examination Dates: <strong>24th October 2026</strong>
                  and <strong>28th November 2026</strong>
                </li>
              </ul>

              <p>
                <b>ALLOTMENT RESULT DATES: </b>
              </p>
              <ul className="list">
                <li>
                  Entrance Test Date:
                  <strong>24th October 2026</strong>.
                  <br/>
                  First Allotment Date:
                  <strong>31st October 2026</strong>.
                  <br />
                   Second Allotment Date:
                  <strong>5th December 2026</strong>.
                </li>
                <li>
                  Entrance Test Date:
                  <strong>28th November 2026</strong>.
                  <br/>
                  {/* First Allotment Date:
                  <strong>5th December 2026</strong>. */}
                </li>
               

              </ul>

              {/* <p>
                <b>SYLLABUS FOR ENTRANCE EXAMINATION </b>
              </p>
              <ul className="list">
              <li>
                <strong>ENGLISH: </strong><br/>
                <strong>Class IX & X</strong>: Integrated Grammar
                </li>

                <li>
                <strong>SCIENCE (PHYSICS, CHEMISTRY AND BIOLOGY): </strong><br/>
                <strong>Class IX</strong>: Motion, Force & Laws of motion, Gravitation, Work & Energy, Sound, Is Matter Around Us Pure, Atoms & Molecules, Structure of Atom, Matter in our Surroundings, Cell, Tissues.  <br/>
                <strong>Class X</strong>: Light, Human Eye and Colourful World, Electricity, Chemical Reaction and Equations, Metals & Non- Metals and Life processes, Reproduction, Carbon & its Compounds. 
                </li>

              <li>
                <strong>MATHEMATICS: </strong><br/>
                <strong>Class IX</strong>: Number System, Polynomials, Co-ordinate Geometry, Linear Equations in two variables, Lines and Angels, Triangles, Quadrilateral, Surface Area and volumes, Circles, Heron's Formula. <br/>
                <strong>Class X</strong>: Real Numbers, Polynomials, Linear Equations in two variables, Introduction of Trigonometry, Co-ordinate Geometry, Probability, Arithmetic Progression, Application of Trigonometry. 
                </li>

              </ul> */}
              <p>
                <b> WEIGHTAGE FOR MERIT LIST </b>
              </p>

              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>S.NO.</th>
                      <th>Criteria</th>
                      <th colspan="3">Points</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Entrance Examination Mark</td>
                      <td colspan="3">As obtained</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Class IX Final Score</td>
                      <td> 20 (90% above) </td>
                      <td> 10 (80% above) </td>
                      <td> 5 (70% above)</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Class X First Semester Score</td>
                      <td>20 (90% above)</td>
                      <td> 10 (80% above)</td>
                      <td> 5 (70% above)</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Sports Achievements</td>
                      <td>10 (State Level)</td>
                      <td> 5 (District Level)</td>
                      <td> 5 (Inter School)</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Arts Achievements</td>
                      <td>10 (State Level)</td>
                      <td> 5 (District Level)</td>
                      <td> 5 (Inter School)</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>St Peter’s 16/A & 88 Branches</td>
                      <td colspan="3">10</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Girl Child Applicant</td>
                      <td colspan="3">5</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>
                        Class X Board Exam
                        <br />
                        <em>(Applicable for interchanging Streams)</em>
                      </td>
                      <td>20 (90% above)</td>
                      <td> 10 (80% above)</td>
                      <td> 5 (70% above)</td>
                    </tr>
                  </tbody>
                </table>
              </div>


              <b>Note: Scholarship applicable to applications received by 31st October 2026.</b> 
              <br/>
              <br/>


              <p>
                <b>SCHOLARSHIP SCHEMES </b>
              </p>
              <ul className="list">
                <li>
                  <strong>
                    Candidates Securing 97% and above in Class X Board:
                  </strong>
                  100% Tuition Fee Exemption.
                </li>
                <li>
                  <strong>
                    Candidates Securing 92% to 96.99% in Class X Board:
                  </strong>
                  50% Tuition Fee Exemption.
                </li>
              </ul>

              <p>
                <b>HOW TO APPLY / CONTACT </b>
              </p>
              <div className="contact">
                For details and Online registration, visit the school office or
                contact:
                <br />
                <br />
                <p>
                  <strong>Phone:</strong> 9560356167
                </p>
                <p>
                  <strong>Email:</strong>
                  <a href="mailto:spetercsfbd@gmail.com">
                    spetercsfbd@gmail.com
                  </a>
                </p>
                <p>
                  <strong>Website:</strong>
                  <a href="http://spcsfbd.ac.in" target="_blank">
                    spcsfbd.ac.in
                  </a>
                </p>
              </div>

              <p>
                <b>SUBJECTS FOR CLASS XI </b>
              </p>

              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th colspan="6">Non-Medical</th>
                    </tr>
                    <tr>
                      <th colspan="5">Compulsory Subjects</th>
                      <th>Elective Subject</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Combination 1</td>
                      <td rowSpan="4" style={{ verticalAlign: 'middle' }}>English</td>
                      <td rowSpan="4" style={{ verticalAlign: 'middle' }}>Physics</td>
                      <td rowSpan="4" style={{ verticalAlign: 'middle' }}>Chemistry</td>
                      <td rowSpan="4" style={{ verticalAlign: 'middle' }}>Mathematics</td>
                      <td>Information Technology / AI</td>
                    </tr>
                    <tr>
                      <td>Combination 2</td>
                      <td>Physical Education</td>
                    </tr>
                    <tr>
                      <td>Combination 3</td>
                      <td>Psychology</td>
                    </tr>
                    <tr>
                      <td>Combination 4</td>
                      <td>Painting</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th colspan="6">Medical</th>
                    </tr>
                    <tr>
                      <th colspan="5">Compulsory Subjects</th>
                      <th>Elective Subject</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Combination 1</td>
                      <td rowSpan="5" style={{ verticalAlign: 'middle' }}>English</td>
                      <td rowSpan="5" style={{ verticalAlign: 'middle' }}>Physics</td>
                      <td rowSpan="5" style={{ verticalAlign: 'middle' }}>Chemistry</td>
                      <td rowSpan="5" style={{ verticalAlign: 'middle' }}>Biology</td>
                      <td>Information Technology / AI</td>
                    </tr>
                    <tr>
                      <td>Combination 2</td>
                      <td>Mathematics</td>
                    </tr>
                    <tr>
                      <td>Combination 3</td>
                      <td>Physical Education</td>
                    </tr>
                    <tr>
                      <td>Combination 4</td>
                      <td>Psychology</td>
                    </tr>
                    <tr>
                      <td>Combination 5</td>
                      <td>Painting</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th colspan="6">Commerce</th>
                    </tr>
                    <tr>
                      <th colspan="5">Compulsory Subjects</th>
                      <th>Elective Subject</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Combination 1</td>
                      <td rowSpan="6" style={{ verticalAlign: 'middle' }}>English</td>
                      <td rowSpan="6" style={{ verticalAlign: 'middle' }}>Accountancy</td>
                      <td rowSpan="6" style={{ verticalAlign: 'middle' }}>Economics</td>
                      <td rowSpan="6" style={{ verticalAlign: 'middle' }}>Business Studies</td>
                      <td>Information Technology / AI</td>
                    </tr>
                    <tr>
                      <td>Combination 2</td>
                      <td>Mathematics</td>
                    </tr>
                    <tr>
                      <td>Combination 3</td>
                      <td>Physical Education</td>
                    </tr>
                    <tr>
                      <td>Combination 4</td>
                      <td>Psychology</td>
                    </tr>
                    <tr>
                      <td>Combination 5</td>
                      <td>Legal Studies</td>
                    </tr>
                    <tr>
                      <td>Combination 6</td>
                      <td>Painting</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th colspan="6">Humanities</th>
                    </tr>
                    <tr>
                      <th colspan="5">Compulsory Subjects</th>
                      <th>Elective Subject</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Combination 1</td>
                      <td rowSpan="5" style={{ verticalAlign: 'middle' }}>English</td>
                      <td rowSpan="5" style={{ verticalAlign: 'middle' }}>Political Science</td>
                      <td rowSpan="5" style={{ verticalAlign: 'middle' }}>History</td>
                      <td rowSpan="5" style={{ verticalAlign: 'middle' }}>Economics</td>
                      <td>Physical Education</td>
                    </tr>
                    <tr>
                      <td>Combination 2</td>
                      <td>Information Technology / AI</td>
                    </tr>
                    <tr>
                      <td>Combination 3</td>
                      <td>Psychology</td>
                    </tr>
                    <tr>
                      <td>Combination 4</td>
                      <td>Legal Studies</td>
                    </tr>
                    <tr>
                      <td>Combination 5</td>
                      <td>Painting</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* <div className="subjectbtn">
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/Stream-Subject-Selection.pdf"
                  target="_blank"
                >
                  Stream and Subject Selection
                </Link>
              </div> */}
              <div className="senior-fee">
                <p>
                  FEE STRUCTURE FOR 2027-28 <br />
                  (SENIOR SECONDARY)
                  <br /> MONTHLY FEES
                </p>
              </div>
              <div className="table-responsive maintable">
                <table className="maintable">
                  <thead>
                    <tr>
                      <th colspan="2">XI NON-MEDICAL</th>
                      <th colspan="2">XI MEDICAL</th>
                      <th colspan="2">XI COMMERCE</th>
                      <th colspan="2">XI HUMANITIES</th>
                    </tr>
                    <tr>
                      <th>WITHOUT IT</th>
                      <th>WITH IT</th>
                      <th>WITHOUT IT</th>
                      <th>WITH IT</th>
                      <th>WITHOUT IT</th>
                      <th>WITH IT</th>
                      <th>WITHOUT IT</th>
                      <th>WITH IT</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>9433</td>
                      <td>9600</td>
                      <td>9600</td>
                      <td>9600</td>
                      <td>7667</td>
                      <td>7833</td>
                      <td>7667</td>
                      <td>7833</td>
                    </tr>
                    <tr>
                      <td colspan="8">
                        For 6th optional Subject Extra of Rs.600/-
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />

              {/* <p>
                <b>ADMISSION FEES</b>
              </p>
              
              <div className="table-responsive maintable">
                <table className="maintable">
                  <tbody>
                    <tr>
                      <td>Fee for New Admission</td>
                      <td>Rs 40000</td>
                    </tr>
                    <tr>
                      <td>Fee for Existing Students</td>
                      <td>Rs 30000</td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
              <br />
              {/* <iframe src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/Fees-Structure-2026-2027.pdf" /> */}
                   <p><a className='bounce1 onlinereg' href='https://entab.online/R-SPCSFBD' target='_blank'>Click Here for Online Registration</a></p>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AdmissionXI
